import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

interface IconButtonProps {
  children?: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
  to?: string;
}

interface StyledButtonProps {
  disabled?: boolean;
  children?: React.ReactNode;
}

interface StyledLinkProps {
  to: string;
  children?: React.ReactNode;
}

const StyledButton = styled.button<StyledButtonProps>`
  align-items: center;
  background-color: ${(props) => (!props.disabled ? 
    localStorage.getItem('theme') === "theme-3" || localStorage.getItem('theme') === "theme-4" 
      ? '#6EBD7044' 
      : '#6EBD70' 
    : props.theme.color.grey[900])};
  border: ${(props) => (!props.disabled ? 
    localStorage.getItem('theme') === "theme-3" || localStorage.getItem('theme') === "theme-4" 
      ? '2px solid #6EBD7066' 
      : '0' 
    : '0')};
  border-radius: 28px;
  color: ${(props) => (!props.disabled ? props.theme.color.primary.main : props.theme.color.grey[500])};
  cursor: pointer;
  display: flex;
  font-weight: 700;
  height: 56px;
  justify-content: center;
  letter-spacing: 1px;
  outline: none;
  padding: 0;
  margin: 0;
  pointer-events: ${(props) => (!props.disabled ? undefined : 'none')};
  text-transform: uppercase;
  width: 56px;
  
  &:hover {
    background-color: ${(props) => (!props.disabled ? 
      localStorage.getItem('theme') === "theme-3" || localStorage.getItem('theme') === "theme-4" 
        ? 'rgba(71, 193, 75, 0.53)' 
        : 'rgba(71, 193, 75, 0.53)' 
      : props.theme.color.grey[900])};
    border: ${(props) => (!props.disabled ? 
      localStorage.getItem('theme') === "theme-3" || localStorage.getItem('theme') === "theme-4" 
        ? '2px solid #6EBD7088' 
        : '0' 
      : '0')};
  }
`;

const StyledLink = styled(Link)<StyledLinkProps>`
  align-items: center;
  color: inherit;
  display: flex;
  flex: 1;
  height: 56px;
  justify-content: center;
  margin: 0 ${(props) => -props.theme.spacing[4]}px;
  padding: 0 ${(props) => props.theme.spacing[4]}px;
  text-decoration: none;
`;

const IconButton = ({ children, disabled, onClick, to }: IconButtonProps) => {
  const hasChildren = React.Children.count(children) > 0;
  const content = hasChildren ? <>{children}</> : null;

  return (
    <StyledButton disabled={disabled} onClick={onClick}>
      {to ? (
        <StyledLink to={to}>{content}</StyledLink>
      ) : (
        content
      )}
    </StyledButton>
  );
};

IconButton.defaultProps = {
  children: null,
  disabled: false,
  onClick: undefined,
  to: undefined,
};

export default IconButton;
